import { postJson } from "../methods";
function getMarketIndustryForIdeas(options, headers = {}) {
  return postJson({
    url: "api/industry/market-investing-ideas",
    payload: {
      ...options
    },
    headers
  });
}
export {
  getMarketIndustryForIdeas as default
};
